import QueryString from "qs";
import API from "../../Api/Api.js";
import { handleError } from "./notifications.js";
const token = localStorage.getItem("token");

export const getNumbers = () => async (dispatch) => {
  dispatch({ type: "STATS_LOADING" });
  API.defaults.headers.common["Authorization"] = token;
  const pagesQuery = QueryString.stringify({
    fields: ["id"],
  });
  const articleQuery = QueryString.stringify({
    fields: ["id", "type"],
    filters: {
      type: {
        $eq: 0,
      },
    },
  });
  const jobsQuery = QueryString.stringify({
    fields: ["id", "type"],
    filters: {
      type: {
        $eq: 1,
      },
    },
  });
  const presseQuery = QueryString.stringify({
    fields: ["id", "type"],
    filters: {
      type: {
        $gt: 2,
      },
    },
  });
  const filesQuery = QueryString.stringify({
    fields: ["id"],
  });
  const partenairesQuery = QueryString.stringify({
    fields: ["id"],
  });
  const contactsQuery = QueryString.stringify({
    fields: ["id"],
  });
  const utilisateursQuery = QueryString.stringify({
    fields: ["id"],
    pagination: {
      pageSize: 10000,
    },
  });
  try {
    const pagesNumber = await API.get(`api/pages/?${pagesQuery}`);
    const articleNumber = await API.get(`api/articles/?${articleQuery}`);
    const jobsNumber = await API.get(`api/articles/?${jobsQuery}`);
    const presseNumber = await API.get(`api/articles/?${presseQuery}`);
    const filesNumber = await API.get(`api/upload/files/?${filesQuery}`);
    const partenairesNumber = await API.get(
      `api/partenaires/?${partenairesQuery}`
    );
    const contactsNumber = await API.get(`api/contacts/?${contactsQuery}`);
    const utilisateursNumber = await API.get(`api/users/?${utilisateursQuery}`);
    console.log(jobsNumber.data.meta.pagination);
    dispatch({
      type: "GET_DB_STATS",
      payload: {
        pagesNumber: pagesNumber.data.meta.pagination.total,
        filesNumber: filesNumber.data.length,
        articleNumber: articleNumber.data.meta.pagination.total,
        jobsNumber: jobsNumber.data.meta.pagination.total,
        presseNumber: presseNumber.data.meta.pagination.total,
        partenairesNumber: partenairesNumber.data.meta.pagination.total,
        contactsNumber: contactsNumber.data.meta.pagination.total,
        utilisateursNumber: utilisateursNumber.data.length,
        // productsNumber: productsNumber.data.meta.pagination.total,
      },
    });
  } catch (error) {
    dispatch(handleError("Erreur Réseau", 1));
    console.log(error);
  }
};
